// Components
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/atoms/dialog";
import { Button } from "@/components/atoms/button";

interface SavedFormData {
  formData: any;
  timestamp: number;
  driverName: string;
}

interface ResumeFormDialogProps {
  showResumeDialog: boolean;
  setShowResumeDialog: (show: boolean) => void;
  savedFormData: SavedFormData | null;
  onResumeEditing: () => void;
  onDiscardSavedData: () => void;
}

export function ResumeFormDialog({
  showResumeDialog,
  setShowResumeDialog,
  savedFormData,
  onResumeEditing,
  onDiscardSavedData,
}: ResumeFormDialogProps) {
  return (
    <Dialog open={showResumeDialog} onOpenChange={setShowResumeDialog}>
      <DialogContent className="sm:max-w-md bg-white">
        <DialogHeader>
          <DialogTitle>Formulario sin guardar</DialogTitle>
          <DialogDescription>
            Se encontró un formulario sin guardar para{" "}
            <span className="font-medium">{savedFormData?.driverName}</span>.
            ¿Deseas continuar editando desde donde lo dejaste o descartarlo?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col-reverse sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={onDiscardSavedData}
            className="w-full sm:w-auto"
          >
            Descartar
          </Button>
          <Button
            onClick={onResumeEditing}
            className="w-full sm:w-auto bg-indigo-600 hover:bg-indigo-700 text-white"
          >
            Continuar editando
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
